// import { useEffect, useState } from "react";
// import { Button, Flex, Modal, message, Table, Input, Spin, Switch } from "antd";
// import {
//   EditOutlined,
//   DeleteOutlined,
//   SearchOutlined,
// } from "@ant-design/icons";
// import UserForm from "./userForm";
// import {
//   deleteUser,
//   fetchUserBaged,
//   postUser,
//   putUser,
// } from "../Service/userService";

// let searchTimeout = null;

// const User = () => {
//   const [users, setUsers] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [page, setPage] = useState(1);
//   const [size, setSize] = useState(10);
//   const [search, setSearch] = useState("");
//   const [sortField, setSortField] = useState("createdDate");
//   const [sortOrder, setSortOrder] = useState("descend");

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editData, setEditData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   // ================= FETCH =================
//   const fetchData = async (
//     pageNum = page,
//     pageSize = size,
//     searchText = search,
//     field = sortField,
//     order = sortOrder
//   ) => {
//     setLoading(true);
//     try {
//       const res = await fetchUserBaged({
//         page: pageNum - 1,
//         size: pageSize,
//         search: searchText || "",
//         sort: field,
//         desc: order === "descend",
//       });

//       setUsers(res.data.content || []);
//       setTotal(res.data.totalElements || 0);
//       setPage(pageNum);
//       setSize(pageSize);
//       setSortField(field);
//       setSortOrder(order);
//     } catch {
//       messageApi.error("Network error while fetching users");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ================= SAVE =================
//   const saveData = async (data) => {
//     setLoading(true);
//     try {
//       if (editData) {
//         await putUser(data, editData.id);
//       } else {
//         await postUser(data);
//       }
//       messageApi.success(`User ${editData ? "updated" : "added"} successfully`);
//       handleCancel();
//       fetchData();
//       return true;
//     } catch {
//       messageApi.error("Error while saving user");
//       return false;
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ================= DELETE =================
//   const deleteData = async (id) => {
//     try {
//       await deleteUser(id);
//       messageApi.success("User deleted successfully");
//       fetchData();
//     } catch {
//       messageApi.error("Error while deleting user");
//     }
//   };

//   const handleCancel = () => {
//     setIsModalOpen(false);
//     setEditData(null);
//     fetchData();
//   };

//   // ================= SEARCH (DEBOUNCE) =================
//   useEffect(() => {
//     clearTimeout(searchTimeout);
//     searchTimeout = setTimeout(() => {
//       fetchData(1, size, search);
//     }, 500);

//     return () => clearTimeout(searchTimeout);
//   }, [search]);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   // ================= COLUMNS =================
//   const columns = [
//     {
//       title: "User Name",
//       dataIndex: "username",
//       key: "username",
//       sorter: true,
//       sortOrder: sortField === "username" ? sortOrder : null,
//     },
//     {
//       title: "Email",
//       dataIndex: "email",
//       key: "email",
//       sorter: true,
//       sortOrder: sortField === "email" ? sortOrder : null,
//     },
//     {
//       title: "Mobile Number",
//       dataIndex: "mobileNumber",
//       key: "mobileNumber",
//       sorter: true,
//       sortOrder: sortField === "mobileNumber" ? sortOrder : null,
//     },
//     {
//       title: "Role",
//       dataIndex: ["role", "roleName"],
//       key: "roleName",
//       sorter: true,
//       sortOrder: sortField === "roleName" ? sortOrder : null,
//     },
//     {
//       title: "Organization",
//       dataIndex: ["firm", "name"],
//       key: "name",
//       sorter: true,
//       sortOrder: sortField === "firm" ? sortOrder : null,
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//       key: "status",
//       render: (val) => (
//         <Switch
//           checked={val}
//           disabled
//           checkedChildren="Active"
//           unCheckedChildren="Inactive"
//         />
//       ),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       align: "center",
//       render: (_, record) => (
//         <>
//           <EditOutlined
//             style={{ marginRight: 12, cursor: "pointer" }}
//             onClick={() => {
//               setEditData(record);
//               setIsModalOpen(true);
//             }}
//           />
//           <DeleteOutlined
//             style={{ cursor: "pointer" }}
//             onClick={() => deleteData(record.id)}
//           />
//         </>
//       ),
//     },
//   ];

//   return (
//     <Spin spinning={loading}>
//       <div style={{ width: "100%" }}>
//         {contextHolder}

//         <Flex
//           justify="space-between"
//           align="center"
//           style={{ marginBottom: 16 }}
//         >
//           <div style={{ fontSize: "1rem", fontWeight: 700 }}>User</div>
//           <Flex gap={8}>
//             <Input
//               placeholder="Search"
//               prefix={<SearchOutlined />}
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//             <Button type="primary" onClick={() => setIsModalOpen(true)}>
//               Add
//             </Button>
//           </Flex>
//         </Flex>

//         <Table
//           rowKey="id"
//           columns={columns}
//           dataSource={users}
//           bordered
//           scroll={{ x: "max-content" }}
//           pagination={{
//             current: page,
//             pageSize: size,
//             total,
//             showSizeChanger: true,
//           }}
//           // onChange={(pagination, filters, sorter) => {
//           //   const field = sorter.field || sortField;
//           //   const order = sorter.order || sortOrder;

//           //   fetchData(
//           //     pagination.current,
//           //     pagination.pageSize,
//           //     search,
//           //     field,
//           //     order
//           //   );
//           // }}
//           onChange={(pagination, filters, sorter) => {
//             const field = Array.isArray(sorter.field)
//               ? sorter.field[sorter.field.length - 1] // roleName
//               : sorter.field || sortField;

//             const order = sorter.order || sortOrder;

//             fetchData(
//               pagination.current,
//               pagination.pageSize,
//               search,
//               field,
//               order
//             );
//           }}
//         />

//         <Modal
//           title={editData ? "Edit User" : "Add User"}
//           centered
//           open={isModalOpen}
//           footer={false}
//           onCancel={handleCancel}
//         >
//           <UserForm editData={editData} saveData={saveData} />
//         </Modal>
//       </div>
//     </Spin>
//   );
// };

// export default User;

import { useEffect, useState } from "react";
import { Button, Flex, Modal, message, Table, Input, Spin, Switch } from "antd";
import { EditOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import UserForm from "./userForm";
import { deleteUser, fetchUserBaged, postUser, putUser } from "../Service/userService";
import usePermission from "../../../../hooks/usePermission";

let searchTimeout = null;

const User = () => {
  const { canCreate, canUpdate, canDelete } = usePermission("CONFIG_USER");

  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState("createdDate");
  const [sortOrder, setSortOrder] = useState("descend");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const fetchData = async (pageNum = page, pageSize = size, searchText = search, field = sortField, order = sortOrder) => {
    setLoading(true);
    try {
      const res = await fetchUserBaged({ page: pageNum - 1, size: pageSize, search: searchText || "", sort: field, desc: order === "descend" });
      setUsers(res.data.content || []);
      setTotal(res.data.totalElements || 0);
      setPage(pageNum); setSize(pageSize); setSortField(field); setSortOrder(order);
    } catch { messageApi.error("Network error while fetching users"); }
    finally { setLoading(false); }
  };

  const saveData = async (data) => {
    setLoading(true);
    try {
      if (editData) { await putUser(data, editData.id); }
      else { await postUser(data); }
      messageApi.success(`User ${editData ? "updated" : "added"} successfully`);
      handleCancel(); fetchData();
      return true;
    } catch { messageApi.error("Error while saving user"); return false; }
    finally { setLoading(false); }
  };

  const deleteData = async (id) => {
    try {
      await deleteUser(id);
      messageApi.success("User deleted successfully");
      fetchData();
    } catch { messageApi.error("Error while deleting user"); }
  };

  const handleCancel = () => { setIsModalOpen(false); setEditData(null); fetchData(); };

  useEffect(() => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => fetchData(1, size, search), 500);
    return () => clearTimeout(searchTimeout);
  }, [search]);

  useEffect(() => { fetchData(); }, []);

  const columns = [
    { title: "User Name", dataIndex: "username", key: "username", sorter: true, sortOrder: sortField === "username" ? sortOrder : null },
    { title: "Email", dataIndex: "email", key: "email", sorter: true, sortOrder: sortField === "email" ? sortOrder : null },
    { title: "Mobile Number", dataIndex: "mobileNumber", key: "mobileNumber", sorter: true },
    { title: "Role", dataIndex: ["role", "roleName"], key: "roleName", sorter: true },
    { title: "Organization", dataIndex: ["firm", "name"], key: "name", sorter: true },
    { title: "Status", dataIndex: "status", key: "status", render: (val) => <Switch checked={val} disabled checkedChildren="Active" unCheckedChildren="Inactive" /> },
    {
      title: "Actions", key: "actions", align: "center",
      render: (_, record) => (
        <>
          {canUpdate && (
            <EditOutlined style={{ marginRight: 12, cursor: "pointer" }} onClick={() => { setEditData(record); setIsModalOpen(true); }} />
          )}
          {canDelete && (
            <DeleteOutlined style={{ cursor: "pointer" }} onClick={() => deleteData(record.id)} />
          )}
        </>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <div style={{ width: "100%" }}>
        {contextHolder}
        <Flex justify="space-between" align="center" style={{ marginBottom: 16 }}>
          <div style={{ fontSize: "1rem", fontWeight: 700 }}>User</div>
          <Flex gap={8}>
            <Input placeholder="Search" prefix={<SearchOutlined />} value={search} onChange={(e) => setSearch(e.target.value)} />
            {canCreate && <Button type="primary" onClick={() => setIsModalOpen(true)}>Add</Button>}
          </Flex>
        </Flex>
        <Table rowKey="id" columns={columns} dataSource={users} bordered scroll={{ x: "max-content" }}
          pagination={{ current: page, pageSize: size, total, showSizeChanger: true }}
          onChange={(pagination, _, sorter) => {
            const field = Array.isArray(sorter.field) ? sorter.field[sorter.field.length - 1] : sorter.field || sortField;
            fetchData(pagination.current, pagination.pageSize, search, field, sorter.order || sortOrder);
          }}
        />
        <Modal title={editData ? "Edit User" : "Add User"} centered open={isModalOpen} footer={false} onCancel={handleCancel}>
          <UserForm editData={editData} saveData={saveData} />
        </Modal>
      </div>
    </Spin>
  );
};

export default User;